import React from 'react';

import '../../styles/organisms/worker-registration-application-confirm-modal.scss';
import Confirmation from '../../components/modals/common/Confirmation';

export const WorkerRegistrationApplicationConfirmModal = ({
  visible,
  onConfirm,
  onCancel,
  selectedPartnerCompanyId,
  partnerCompanyIdOfPrimeCompany,
}) => (
  <Confirmation
    title='作業員の代行登録を申請する'
    rootClassName='WorkerRegistrationApplicationConfirmModal'
    visible={visible}
    message={
      <div>
        <p className='WorkerRegistrationApplicationConfirmModal__title'>
          本画面の「同意して申請する」ボタンをクリックすることで、以下の内容に同意されたものとみなします。
        </p>
        <p>
          ・申請者は、以下のBuildee利用規約及びプライバシーポリシーを読み、同意をしていること。
        </p>
        <p>
          {selectedPartnerCompanyId === partnerCompanyIdOfPrimeCompany
            ? '・申請者は、登録する作業員の個人情報が第三者（リバスタ、建設現場の元請企業、及びBuildeeの登録ユーザーで、作業員が入場し、又は入場した現場の元請企業、上位下請事業者）に提供されることにつき、利用目的を明示した上で同意を取得していること。'
            : '・申請者は、登録する作業員の個人情報が第三者（リバスタ、建設現場の元請企業、及びBuildeeの登録ユーザーで、作業員が入場し、又は入場した現場の元請企業、上位下請事業者）に提供されることにつき、利用目的を明示した上で同意を取得していることを、委託元より確認していること。'}
        </p>
        <p>・内容確認のため、当社が申請者に連絡することがあること。</p>
        <p>
          ・作業員名簿データは正規の手順を踏んで入手しており、内容に虚偽がないこと。
        </p>
        <div className='WorkerRegistrationApplicationConfirmModal__links'>
          <div>
            Buildee利用規約：
            <a
              className='clickable-text'
              href='https://service.buildee.jp/support/agreement/'
              target='_blank'
              rel='noreferrer noopener'
            >
              https://service.buildee.jp/support/agreement/
            </a>
          </div>
          <div>
            プライバシーポリシー：
            <a
              className='clickable-text'
              href='https://www.rvsta.co.jp/privacypolicy/'
              target='_blank'
              rel='noreferrer noopener'
            >
              https://www.rvsta.co.jp/privacypolicy/
            </a>
          </div>
        </div>
        <p className='WorkerRegistrationApplicationConfirmModal__footnote'>
          作業員の代行登録は申請受付順に処理します。
          <br />
          また、申請いただいた作業員の人数や内容、申請状況によっては処理完了までに時間がかかる可能性があります。
          <br />
          お問い合わせ窓口に優先対応依頼や作業完了日をお問い合わせいただいてもお答えできませんのでご了承ください。
        </p>
        <p className='WorkerRegistrationApplicationConfirmModal__footnote'>
          お急ぎの場合はご自身でBuildee画面上から登録を行っていただけますようお願いいたします。
        </p>
      </div>
    }
    confirmButtonText='同意して申請する'
    cancelButtonText='戻る'
    onConfirm={onConfirm}
    onCancel={onCancel}
  />
);



// WEBPACK FOOTER //
// ./src/components/modals/WorkerRegistrationApplicationConfirmModal.jsx